module.exports = __webpack_public_path__ + "static/media/Billing.4405173b.png";